export default __webpack_public_path__ + "static/media/sprint.19005bc7.png";